var lists_default = {
  "fontElementMap": "s0p-1",
  "orderedlist": "Jw3SN",
  "bulletedlist": "KLy2U",
  "listItem": "AD3eY"
};
export {
  lists_default as default
};
//# sourceMappingURL=lists-scss.js.map
